export default __webpack_public_path__ + "static/media/h6.01f8a8c9.jpg";